import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface MediaPreviewDialogData {
  mediaUrl: string;
  mediaType: "image" | "video";
  posterUrl?: string;
  title?: string;
}

@Component({
  selector: "app-media-preview-dialog",
  templateUrl: "./media-preview-dialog.component.html",
  styleUrls: ["./media-preview-dialog.component.scss"],
})
export class MediaPreviewDialogComponent {
  loadError = false;

  constructor(
    public dialogRef: MatDialogRef<MediaPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MediaPreviewDialogData
  ) {}

  onMediaError(): void {
    this.loadError = true;
  }

  close(): void {
    this.dialogRef.close();
  }
}
